import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { errMsg, getAuthorName, getPref, http, setAuthorName } from "../lib/api";
import { buildStyle, ENGINES, findItem, LLMS } from "../lib/presets";

const INITIAL = () => ({ description: "", title: "", lyrics: "", extra: "", genre: "", moods: [], voice: "",
  instrumental: false, engine: getPref("engine", ENGINES), llm: getPref("llm", LLMS), compare: getPref("compare", ENGINES),
  compareOn: false, length: "medium", variants: 1, author: getAuthorName(), isPublic: true, parentId: null });

export const compareOptions = (engine, instr) => ENGINES.filter((e) => e.id !== engine && e.id !== "yue_local"
  && (instr ? !e.needsLyrics : !e.instrumentalOnly));

const validate = (mode, f, style) => {
  if (mode === "simple" && !f.description.trim()) return "Įveskite dainos aprašymą";
  if (mode === "custom" && !f.instrumental && !f.lyrics.trim()) return "Įveskite dainos žodžius arba pasirinkite instrumentinę";
  if (mode === "custom" && !style) return "Nurodykite muzikos stilių (žanrą arba papildomą stilių)";
  return "";
};

const payload = (mode, f, style, comparing) => ({
  mode, description: f.description, title: f.title, style, genre: f.genre, lyrics: mode === "custom" ? f.lyrics : "",
  instrumental: f.instrumental, engine: f.engine, llm: f.llm, length: f.length, variants: comparing ? 1 : f.variants,
  compare_engine: comparing ? findItem(compareOptions(f.engine, f.instrumental), f.compare).id : null,
  author_name: f.author.trim() || "Anonimas", is_public: f.isPublic, parent_id: f.parentId,
});

const useRemix = (setMode, setF) => {
  const [params, setParams] = useSearchParams();
  useEffect(() => { if (params.get("cover")) setMode("cover"); }, [params, setMode]);
  useEffect(() => {
    const id = params.get("remix");
    if (!id) return;
    http.get(`/songs/${id}`).then(({ data }) => {
      setMode("custom");
      setF((s) => ({ ...s, title: `${data.title} (remiksas)`, lyrics: data.lyrics, extra: data.style, genre: "",
        instrumental: data.instrumental, parentId: data.id }));
      toast.success("Daina įkelta remiksui");
      setParams({});
    });
  }, [params, setParams, setMode, setF]);
  return params.get("cover");
};

export const useCreateForm = (onCreated) => {
  const [mode, setMode] = useState("simple");
  const [f, setF] = useState(INITIAL);
  const [busy, setBusy] = useState(false);
  const coverId = useRemix(setMode, setF);
  const set = useCallback((k) => (v) => setF((s) => ({ ...s, [k]: v })), []);
  const eng = findItem(ENGINES, f.engine);
  const instr = !!eng.instrumentalOnly || (!eng.needsLyrics && f.instrumental);
  const comparing = f.compareOn && f.engine !== "yue_local";

  const submit = async () => {
    const style = buildStyle(f.genre, f.moods, f.voice, f.extra);
    const form = { ...f, instrumental: instr };
    const problem = validate(mode, form, style);
    if (problem) return toast.error(problem);
    setBusy(true);
    setAuthorName(f.author);
    try {
      await http.post("/songs", payload(mode, form, style, comparing));
      toast.success(comparing ? "Kuriamos 2 versijos palyginimui! Atidarykite dainą, kad palygintumėte." : "Daina kuriama! Tai užtruks ~1–3 min.");
      onCreated();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return { mode, setMode, f, setF, set, eng, instr, comparing, busy, submit, coverId };
};
